var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[(_vm.driverDetails)?[_c(_vm.componentConfig.type,_vm._b({tag:"component"},'component',_vm.componentConfig.propsData,false))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }